export const AUTH_PENDING_KEY = 'lumi:authPending';
const TTL_MS = 60_000; // 1 minute safety window

export function markAuthPending(ttlMs: number = TTL_MS) {
  try {
    sessionStorage.setItem(AUTH_PENDING_KEY, String(Date.now() + ttlMs));
  } catch {}
}

export function clearAuthPending() {
  try {
    sessionStorage.removeItem(AUTH_PENDING_KEY);
  } catch {}
}

export function isAuthPending(): boolean {
  try {
    const v = sessionStorage.getItem(AUTH_PENDING_KEY);
    return !!v && Date.now() < Number(v);
  } catch {
    return false;
  }
}


